module.exports = __webpack_public_path__ + "static/vvi-7233b75b660eb7445af278b916d726f0.png";